import React from 'react'
import PropTypes from 'prop-types'
import { connect } from 'react-redux'
import { withTranslation } from 'react-i18next'
import DownloadsActions, { thunks as DownloadsThunks } from 'reducers/Downloads'
import { thunks as ProfileThunks } from 'reducers/Profile'
import { CustomInputSelect, DownloadMenuCell } from 'components'
import { SettingsIcon, ArrowBackIcon } from 'images'
import { AudioFormat } from 'constants/enums'

const mapStateToProps = ({ downloads, profile }) => {
  return {
    profile: profile.profile,
    downloads: downloads.downloads
  }
}
@connect(mapStateToProps, null)
class DownloadMenu extends React.PureComponent {
  static propTypes = {
    downloads: PropTypes.arrayOf(PropTypes.object),
    profile: PropTypes.object.isRequired,
    dispatch: PropTypes.func.isRequired,
    t: PropTypes.func.isRequired
  }
  static defaultProps = {
    downloads: []
  }
  state = {
    isSettingsOpen: false
  }
  onDownloadFormatChange = (format) => {
    const { dispatch, profile } = this.props
    dispatch(ProfileThunks.postProfile({ ...profile, format }))
  }
  handleRestartDownload = (download) => {
    const { dispatch } = this.props
    dispatch(DownloadsThunks.restartDownload(download, 'download_menu'))
  }
  handleRemoveDownload = (download) => {
    const { dispatch } = this.props
    dispatch(DownloadsThunks.removeDownload(download))
  }
  handleClearCompleted = () => {
    const { dispatch } = this.props
    dispatch(DownloadsActions.removeFinished())
  }
  handleOpenSettings = () => {
    this.setState({ isSettingsOpen: true })
  }
  handleCloseSettings = () => {
    this.setState({ isSettingsOpen: false })
  }

  render() {
    const { isSettingsOpen } = this.state
    const { profile, downloads, t } = this.props

    const formatOptions = [
      {
        name: t(AudioFormat.wav.display),
        value: AudioFormat.wav.value
      },
      {
        name: t(AudioFormat.mp3.display),
        value: AudioFormat.mp3.value
      }
    ]
    const downloadItems = downloads.map((download) => {
      const {
        downloadID,
        coverart,
        artist,
        version,
        is_ai_generated,
        explicit,
        title,
        type,
        trackcount,
        zippingProgress,
        zipperReady,
        progress,
        status
      } = download
      return (
        <DownloadMenuCell
          key={downloadID}
          download={download}
          downloadID={downloadID}
          coverart={coverart}
          artist={artist}
          version={version}
          isAIGenerated={is_ai_generated}
          explicit={explicit}
          title={title}
          type={type}
          status={status}
          trackcount={trackcount}
          zippingProgress={zippingProgress}
          zipperReady={zipperReady}
          percentCompleted={progress}
          onRemoveDownload={this.handleRemoveDownload}
          onRestartDownload={this.handleRestartDownload} />
      )
    })
    return (
      <div className="w-104 mx-2 bg-gray-860 border border-gray-770 rounded overflow-hidden text-gray-225">
        <div className="h-16 mx-6 flex items-center justify-between border-b border-gray-770 font-header text-sm">
          <button
            type="button"
            className="py-2 pr-2 pl-0 focus:outline-none text-gray-225"
            onClick={
              isSettingsOpen
                ? this.handleCloseSettings
                : this.handleClearCompleted
            }>
            {isSettingsOpen ? (
              <ArrowBackIcon className="overflow-visible" />
            ) : (
              <p className="underline">
                {t('download-manager.clear-completed')}
              </p>
            )}
          </button>
          <button
            type="button"
            className="py-2 pl-2 pr-0 focus:outline-none flex items-center text-gray-225"
            onClick={this.handleOpenSettings}>
            <p className="pr-3">{t('download-manager.download-settings')}</p>
            <SettingsIcon
              width={16}
              height={16}
              className="block flex-shrink-0 overflow-visible" />
          </button>
        </div>
        {isSettingsOpen ? (
          <div className="flex flex-col h-72 px-6 py-8 text-sm font-header">
            <div className="pb-6 w-full flex flex-col">
              <p className="pb-4">{t('download-manager.select-label')}</p>
              <CustomInputSelect
                selected={profile.format}
                options={formatOptions}
                handleChange={this.onDownloadFormatChange} />
            </div>
            <div className="flex items-center">
              <p className="">{t('download-manager.warning')}</p>
            </div>
          </div>
        ) : (
          <div
            className={`scrollbar-black py-4 overflow-y-auto ${
              downloads.length === 0 ? 'h-72' : ''
            }`}
            style={downloads.length === 0 ? undefined : { maxHeight: 384 }}>
            {downloads.length === 0 ? (
              <div className="flex justify-center items-center h-full w-full">
                <p className="font-header text-sm">
                  {t('download-manager.no-downloads')}
                </p>
              </div>
            ) : (
              downloadItems
            )}
          </div>
        )}
      </div>
    )
  }
}
export default withTranslation()(DownloadMenu)
